import script from "./ForumTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumTable.vue?vue&type=script&setup=true&lang=js"

import "./ForumTable.vue?vue&type=style&index=0&id=ac62bd90&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac62bd90"]])

export default __exports__